module.exports = __webpack_public_path__ + "media/images/gerika-ee94a8ba5af95626dbcbfd13aa7b1c27.png";